import React, { useState } from "react";
import DialogWrapper from "../common/DialogWrapper";
import { useSelectorTyped as useSelector, useThunkDispatch } from "../../redux/common";
import { close, refreshUserData } from "../../redux/user/user-actions";
import { Button, CircularProgress } from "@material-ui/core";
import { callGqlApi } from "../../helpers/api";
import { handleGqlErrors } from "../../redux/gql-error/gql-error-actions";

function NewVUEupdate() {
  const mode = useSelector(state => state.user.VUEUpdate);
  const open = mode === "accept" || mode === "view";
  const dispatch = useThunkDispatch();
  const [loading, setLoading] = useState(false);

  function buttons(mode, cancelAction, okAction) {
    if (mode === "accept") {
      return (
        <>
          {loading && (
            <div style={{ padding: 8 }}>
              <CircularProgress size={25} />
            </div>
          )}
          <Button variant="contained" color="primary" onClick={okAction} disabled={loading}>
            Dismiss
          </Button>
        </>
      );
    } else {
      return (
        <Button variant="outlined" onClick={() => dispatch(close())}>
          Close
        </Button>
      );
    }
  }

  function accept() {
    setLoading(true);
    callGqlApi(`
      mutation {
        acceptVUEupdate
      }
    `)
      .then(() => {
        dispatch(refreshUserData()).then(() => {
          mode == "closed";
          dispatch(close());
          setLoading(false);
          dispatch(close());
        });
      })
      .catch(e => dispatch(handleGqlErrors(e)));
  }

  return (
    <DialogWrapper
      open={open}
      title={"NEW!  INNOVASEA GENERATION 2 CODE MAP"}
      cancelAction={() => dispatch(close())}
      okAction={accept}
      buttons={({ cancelAction, okAction }) => buttons(mode, cancelAction, okAction)}
      maxWidth="md"
    >
      <p>
        Update your 69 kHz receivers to <b>Innovasea Generation 2</b> and say goodbye to the hassle
        of configuring receiver code maps!
      </p>
      <p>
        With Generation 2,{" "}
        <b>
          you will detect MAP-114, MAP-115, and future 69 kHz Innovasea tag code spaces without any
          extra work.{" "}
        </b>
      </p>
      <p>
        To update your receivers today, follow the instructions at{" "}
        <a href="https://support.fishtracking.innovasea.com/s/article/How-do-I-update-my-69-kHz-receiver-to-Innovasea-Generation-2">
          How do I update my 69 kHz receiver to Innovasea Generation 2?{" "}
        </a>
      </p>
      <p>
        For more details on code spaces supported by Generation 2, visit{" "}
        <a href="https://support.fishtracking.innovasea.com/s/article/Which-receiver-code-maps-support-the-transmitter-code-spaces-I-am-using">
          Which receiver code maps support the transmitter code spaces I am using?
        </a>
      </p>
    </DialogWrapper>
  );
}

export default NewVUEupdate;
